import React from 'react'
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext'
import './index.css'

import GoogleLoginButton from '../../components/Interactables/Misc/GoogleLoginButton'
import LogoutButton from '../../components/Interactables/Misc/LogoutButton'

function AuthPage() {
  const { user, loginWithGoogle, logout } = useAuth()
  return (
    <div>
        {!user ? (
        <div className="auth-container">
            <div className="auth-content">
                <div className="auth-header">
                    <h1>Welcome to DevBoard</h1>
                    <p>Sign in to access your boards and projects</p>
                </div>
                <div className="auth-options">
                    <GoogleLoginButton />
                </div>
                <div className="auth-footer">
                    <p>By signing in, you agree to our Terms of Service and Privacy Policy</p>
                </div>
            </div>
        </div>
        ) : (
            <div>
            <Navigate to='/'/>
            <LogoutButton />
           </div>
        )}
    </div>
    )
}   

export default AuthPage
